import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SummitUtilService } from '@summit/utils';
import { environment } from 'environments/environment';
import { Observable, of as ObservableOf } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

import { WebApplicationsService, AppUrl } from '@summit/application-list';

@Injectable({providedIn: 'root'})
export class AuthGuard  {

  constructor(
    private authService: AuthenticationService,
    private summitUtils: SummitUtilService,
    private webApplicationsService: WebApplicationsService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    if (!environment.production) {
      return ObservableOf(true);
    } else {
      return this.authService.isLoggedIn().pipe(
        flatMap(isLoggedIn => {
          if (isLoggedIn) {
            return this.authService.getCredentials().pipe(
              map(creds => {
                if (creds && creds['uuid']) { // user is logged in
                  this.webApplicationsService.getAppUrl('BUSINESS_CENTER', [], environment.restfulServices, environment.production)
                    .subscribe((appUrl: AppUrl) => window.open(appUrl.url, appUrl.openTarget));
                } else { // user is not logged in
                  return true;
                }
                return true;
              })
            );
          } else {
            return ObservableOf(true);
          }
        }),
          catchError(error => {
          return this.summitUtils.errorHandlerImpl(error, 'Failed to check if user is logged in.', environment.production);
        })
      );
    }
  }
}
